export default "__VITE_ASSET__BiwmGNVp__"